import React, { useMemo, useState, useRef, useEffect } from 'react';
import { Card, Col, Row, Button } from 'react-bootstrap';
import PageTitle from '../../includes/PageTitle';
import Tables from "../../components/Tables/Tables";
import Modals from "../../components/Modals/Modals";
import SelectFild from '../../components/SelectFild/SelectFild';
import Alert from 'react-bootstrap/Alert';
import { useFormik } from 'formik';
import { ToastContainer, toast } from 'react-toastify';
import Loader from '../../components/Loader/Loader';
import { FaFile, FaTrashAlt } from "react-icons/fa";
import pdfUrl from '../../assets/pdf/Gratuity.pdf'
import { postCommonMaster, postDocument, getDocumentDetails, postDocumentSave, deleteDocument } from '../../apiservices/ApiServices';

const DocumentType = () => {
    const [show, setShow] = useState(false);
    const [isLoading, setLoading] = useState(true);
    const [isLoadings, setLoadings] = useState(false);
    const [addModal, setAddModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [viewModal, setViewModal] = useState(false);
    const [data, setData] = useState([]);
    const [commonMaster, setCommonMaster] = useState([]);
    const [files, setFiles] = useState([]);
    const [deleteIds, setDeleteIds] = useState([]);

    const postDocuments = async (postData) => {
        setLoading(true);
        try {
            const res = await postDocument(postData);
            setData(res.data.data);
            setLoading(false);
            console.log(res.data.data)
        } catch (error) {
            setLoading(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    const postUpdateDocuments = async () => {
        let postData = {
            search: "",
            filters: {
                document_title: ""
            },
            page: 1,
            length: 100
        }
        try {
            const res = await postDocument(postData);
            setData(res.data.data);
        } catch (error) {
            console.log(error.response?.data?.message || "Error submitting data");
        }
    };

    useEffect(() => {
        let postData = {
            search: "",
            filters: {
                document_title: ""
            },
            page: 1,
            length: 100
        }
        postDocuments(postData);
    }, []);

    const handleDrop = (e) => {
        e.preventDefault();
        const droppedFiles = Array.from(e.dataTransfer.files);
        handleFiles(droppedFiles);
    };

    const handleFileSelect = (e) => {
        const selectedFiles = Array.from(e.target.files);
        handleFiles(selectedFiles);
    };

    const handleFiles = (fileList) => {
        console.log(fileList);

        setFiles(prev => [...prev, ...fileList]);

        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };

    const removeFile = (index, fileid) => {
        if (isEdit && fileid !== '') {
            setDeleteIds((prev) => [...prev, Number(fileid)]);
        }

        setFiles(prev => prev.filter((_, i) => i !== index));
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        e.currentTarget.classList.add('dragover');
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        e.currentTarget.classList.remove('dragover');
    };
    const fileInputRef = useRef(null);

    const columns = useMemo(
        () => [
            {
                Header: "Document Name",
                accessor: "document_title",
            },
            {
                Header: "Document Type",
                accessor: "document_type",
                Cell: ({ value }) => <span>{value?.name}</span>
            },
            {
                Header: "Action",
                accessor: "action",
                disableSortBy: true,
            },
        ],
        []
    );

    const actions = ['edit', 'delete']
    const subActions = []

    const addnew = async () => {
        formik.resetForm();
        setLoadings(true);
        setFiles([]);
        setIsEdit(false);
        let postData = {
            type: [
                "billing_entity",
                "document_type"
            ],
            org_type_code: ''
        }
        try {
            const res = await postCommonMaster(postData);
            setCommonMaster(res.data.data);
            setLoadings(false);
            setAddModal(true);
        } catch (error) {
            setLoadings(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    const initialValues = {
        id: '',
        documentName: '',
        documentType: '',
        billingEntityId: '',
    }

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: '',
        onSubmit: async (values) => {
            setLoadings(true);
            const formData = new FormData();
            if (isEdit) {
                formData.append('document_id', values.id);
                formData.append('deleted_file_ids', JSON.stringify(deleteIds));
            }
            formData.append('document_title', values.documentName);
            formData.append('document_type_id', values.documentType);
            formData.append('billing_entity_id', values.billingEntityId);

            if (files && files.length > 0) {
                Array.from(files).forEach((file) => {
                    formData.append('files[]', file);
                });
            }
            try {
                const res = await postDocumentSave(formData);
                toast.success(res.data.message);
                setLoadings(false);
                setAddModal(false);
                postUpdateDocuments();
            } catch (error) {
                setLoadings(false);
                toast.error(error.response?.data?.message || "Error submitting data");
            }
        },
    });
    const { values, handleChange, handleBlur, handleSubmit, setFieldValue, errors, touched } = formik;

    const handleConfirm = () => {
        setAddModal(false);
        setIsEdit(false);
        setViewModal(false);
        formik.resetForm();
    };

    const handleEdit = async (rowData) => {
        setLoadings(true);
        let postData = {
            type: [
                "billing_entity",
                "document_type"
            ],
            org_type_code: ''
        }
        try {
            const ress = await postCommonMaster(postData);
            setCommonMaster(ress.data.data);

            try {
                const res = await getDocumentDetails(rowData?.document_id);
                setFieldValue('id', res?.data?.data?.document_id);
                setFieldValue('documentName', res?.data?.data?.document_title);
                setFieldValue('documentType', res?.data?.data?.document_type?.id);
                setFieldValue('billingEntityId', res?.data?.data?.billing_entity_id);
                setFiles(res?.data?.data?.files);

                setLoadings(false);
                setIsEdit(true);
                setAddModal(true);

            } catch (error) {
                setLoadings(false);
                setIsEdit(false);
                setAddModal(false);
            }


        } catch (error) {
            setLoadings(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }



    }

    const handleDelete = (rowData) => {
        setShow(true);
        setFieldValue('id', rowData?.document_id);
        setFieldValue('documentName', rowData?.document_title);
    };

    const handleDeleteCon = async () => {
        setLoadings(true);
        try {
            const res = await deleteDocument(values.id);
            console.log(res.data)
            toast.success(res.data.message);
            setLoadings(false);
            setShow(false);
            postUpdateDocuments();
            setFieldValue('id', '');
            setFieldValue('documentName', '');
        } catch (error) {
            setLoadings(false);
            setShow(false);
        }
    };

    return (
        <>
            <ToastContainer
                position="top-right"
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                style={{ zIndex: 9999999999, position: 'fixed' }}
            />
            {isLoading ? <Loader /> :
                <>
                    <PageTitle titles='Document Type' active='Document Type' items={['Home']} />
                    <Row>
                        <Col sm={12} className="col-12">
                            <Card>
                                <Card.Body className="example1-table">
                                    <div className='custompageHed'>
                                        <Row>
                                            <Col md={6}>
                                                <div className='pagetitle_hed'>
                                                    <h1>Document Type</h1>
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className='w-100 d-flex justify-content-end'>
                                                    <button type='button' className='btn btn-primary' onClick={() => addnew()}>Add New</button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>

                                    <Tables
                                        columns={columns}
                                        data={data?.records}
                                        actions={actions}
                                        subActions={subActions}
                                        onEdit={handleEdit}
                                        onDelete={handleDelete}
                                    />
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </>
            }

            <Modals
                show={addModal}
                handleClose={() => setAddModal(false)}
                title={isEdit ? 'Edit Document Type' : 'Add New'}
                textColor='#000'
                size='lg'
                centered={true}
                backdrop={true}
                onConfirm={handleConfirm}
            >
                <form onSubmit={handleSubmit} autoComplete="off">
                    <Row>
                        <Col md={4}>
                            <div className="form-group">
                                <label className="form-label">Document Name</label>
                                <input
                                    type='text'
                                    id="documentName"
                                    name="documentName"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.documentName}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.documentName && touched.documentName && (
                                    <p className="errormsg">{errors.documentName}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="form-group">
                                <label className="form-label">Select Document Type</label>
                                <SelectFild
                                    Firstop='Select Document Type'
                                    selectName="documentType"
                                    options={commonMaster?.document_type}
                                    value={values.documentType}
                                    onChange={(selectedOption) => setFieldValue("documentType", selectedOption?.value || "")}
                                    onBlur={handleBlur}
                                />
                                {errors.documentType && touched.documentType && (
                                    <p className="errormsg">{errors.documentType}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="form-group">
                                <label className="form-label">Select Billing Entity</label>
                                <SelectFild
                                    Firstop='Select Billing Entity'
                                    selectName="billingEntityId"
                                    options={commonMaster?.billing_entity}
                                    value={values.billingEntityId}
                                    onChange={(selectedOption) => setFieldValue("billingEntityId", selectedOption?.value || "")}
                                    onBlur={handleBlur}
                                />
                                {errors.billingEntityId && touched.billingEntityId && (
                                    <p className="errormsg">{errors.billingEntityId}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className='fieldsets'>
                                <div className='fieldsetsboxs'>
                                    <h6>Upload</h6>
                                </div>
                                <div className="formsBox upload-container">
                                    <div
                                        className="drop-zone"
                                        onDragOver={handleDragOver}
                                        onDragLeave={handleDragLeave}
                                        onDrop={handleDrop}
                                    >
                                        <p>Drag & Drop Here</p>
                                        <p>or</p>
                                        <button
                                            type="button"
                                            onClick={() => fileInputRef.current?.click()}
                                            className="select-button btn btn-primary"
                                        >
                                            Select Files
                                        </button>
                                        <input
                                            ref={fileInputRef}
                                            type="file"
                                            accept="image/*,.pdf,.xlsx,.xls,.xlsm,.xlsb, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                            multiple
                                            onChange={handleFileSelect}
                                            style={{ display: 'none' }}
                                        />
                                    </div>

                                    {files.length > 0 && (
                                        <div className="previewsimges col_3">
                                            {files.map((file, index) => (
                                                <div key={index} className='imageboxs'>
                                                    <div className='imgs pdfs'>
                                                        <div>

                                                            <div className='acbox'>
                                                                <button type='button' onClick={() => removeFile(index, file?.document_file_id)} className='btn btn-removed'><FaTrashAlt /></button>
                                                            </div>


                                                            <div className="pdf-icon">
                                                                <FaFile size={48} color="#e74c3c" />
                                                            </div>
                                                            {file?.file_name ?
                                                                <>
                                                                    <p>{file.file_name}</p>
                                                                    <a href={file.file_url} target="_blank" className='btn btn-primary' rel="noopener noreferrer">view File</a>
                                                                </>
                                                                : <>
                                                                    <p> {file.name}</p>
                                                                    {/* <a href={pdfUrl} target="_blank" className='btn btn-primary' rel="noopener noreferrer">view Pdf</a> */}
                                                                </>}

                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <div className='modalfooters'>
                        <div className='button-boxs grid'>
                            <button type='submit' className='btn btn-primary'>{isEdit ? "Update" : 'Save'}</button>
                            <button type='button' onClick={handleConfirm} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </form>
            </Modals>



            {show ? (<>
                <Alert variant="danger" onClose={() => setShow(false)} dismissible>
                    <Alert.Heading>Are you sure want to Delete <span>{values.documentName}</span> Document Type?</Alert.Heading>
                    <hr />
                    <div className='button-boxs grid'>
                        <div>
                            <button onClick={() => handleDeleteCon()} className='btn btn-primary'>OK</button>
                        </div>
                        <div>
                            <button onClick={() => setShow(false)} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </Alert>
                <div className='overly'></div>
            </>) : null}

            {isLoadings && <Loader />}
        </>
    )
}

export default DocumentType